let sendEvent = {
  params: {
    eventCategory: null,
    action: {
      ya: null,
      ga: null,
      fb: null,
      vk: null,
    },
    shortcutValue: null
  },
  openThesis(lection_id) {
    this.params.action.ga = 'Open thesis';
    this.params.eventCategory = 'User Action';
    this.params.shortcutValue = lection_id;
    this.send();
  },
  playVideoArchive(lection_id) {
    this.params.action.ga = 'Play video archive';
    this.params.eventCategory = 'User Action';
    this.params.shortcutValue = lection_id;
    this.send();
  },
  testStart(lection_id) {
    this.params.action.ga = 'Test Start';
    this.params.eventCategory = 'User Action';
    this.params.shortcutValue = lection_id;
    this.send();
  },
  nmoConnect() {
    this.params.action.ga = 'Try NMO connect';
    this.params.eventCategory = 'User Action';
    this.send();
  },
  nmoConnectSuccess() {
    this.params.action.ga = 'NMO connected';
    this.params.eventCategory = 'User Action';
    this.send();
  },
  newNmoCode(lection_id) {
    this.params.action.ga = 'User get code NMO';
    this.params.eventCategory = 'User Action';
    this.params.shortcutValue = lection_id;
    this.send();

  },
  testEnd(lection_id) {
    this.params.action.ga = 'Test Finish';
    this.params.eventCategory = 'User Action';
    this.params.shortcutValue = lection_id;
    this.send();
  },
  errorStream(lection_id) {
    this.params.action.ga = 'Stream activity error';
    this.params.eventCategory = 'System error';
    this.params.shortcutValue = lection_id;
    this.send();
  },
  saleEvent(eventId, ticketId) {
    this.params.action.ga = eventId;
    this.params.eventCategory = 'Sale of the event';
    this.params.action.fb = 'Purchase';
    this.params.shortcutValue = ticketId;
    this.send();
  },
  forgotPass() {
    this.params.action.ga = 'pas SMS request';
    this.params.eventCategory = 'User Action';
    this.send();
  },
  userComment(lection_id) {
    this.params.action.ga = 'lection new comment';
    this.params.eventCategory = 'User Action';
    this.params.shortcutValue = lection_id;

    this.send();
  },
  attemptBuy(eventId, ticketId) {
    this.params.action.ga = eventId;
    this.params.action.vk = 'add_to_cart';
    this.params.eventCategory = 'Try buy event';
    this.params.shortcutValue = ticketId;
    this.send();
  },
  newUser() {
    this.params.action.ga = 'registration';
    this.params.action.ym = 'user_action_registration';
    this.params.action.fb = 'CompleteRegistration';
    this.params.action.vk = 'complete_registration';
    this.params.eventCategory = 'User Action';
    this.send();
  },
  paidCourse(course_id) {
    this.params.action.ga = 'course sale';
    this.params.action.ym = 'user_action_course_sale';
    this.params.action.fb = 'Purchase';
    this.params.action.vk = 'conversion';
    this.params.eventCategory = 'Sale of the course';
    this.params.shortcutValue = course_id;
    this.send();
  },
  signUpForCourse() {
    this.params.action.ym = 'zapis-na-kurs';
    this.send();
  },
  sendQuestionnaire() {
    this.params.action.ym = 'anketa-kurs';
    this.send();
  },
  paidCertificateOrder() {
    this.params.action.fb = 'Purchase';
    this.send();
  },
  paidUserProSubscription(pro_type) {
    this.params.action.ga = 'user pro sale';
    this.params.action.ym = 'user_action_user_pro_sale';
    this.params.action.fb = 'Purchase';
    this.params.eventCategory = 'Sale of the user pro subscription';
    this.params.shortcutValue = pro_type;
    this.send();
  },
  enrollInCourses() {
    this.params.action.vk = 'initiate_checkout';
    this.params.action.fb = 'InitiateCheckout';
    this.send();
  },
  regStep_1() {
    this.params.action.ym = 'user_action_registration_step1';
    this.params.action.vk = 'contact';
    this.params.eventCategory = 'User Action';
    this.send();
  },
  regStep_2() {
    this.params.action.ym = 'user_action_registration_step2';
    this.params.action.fb = 'Lead';
    this.params.eventCategory = 'User Action';
    this.send();
  },
  regStep_3() {
    this.params.action.ym = 'user_action_registration_step3';
    this.params.eventCategory = 'User Action';
    this.send();
  },
  send() {
    var params = this.params;

    if (typeof yaCounter35148630 === "undefined") {

      console.warn('Object yaCounter does not exist');

    } else if (params.action.ym !== null) {
      yaCounter35148630.reachGoal(params.action.ym, {
        "Категория": params.eventCategory,
        "Значение": params.shortcutValue
      });
    }

    if (typeof fbq !== 'undefined' && params.action.fb) {
      fbq('track', params.action.fb);
    }

    if (typeof VK !== 'undefined') {
      VK.Goal(params.action.vk)
    }

  },
  action(action, entity_id, entity_type) {

    $.ajax({
      url: '/action/send-event',
      type: "POST",
      data: {
        action: action,
        entity_id: entity_id,
        entity_type: entity_type
      },
      success: function () {
        console.log('write action');
      }
    });

  }
};
window.sendEvent = sendEvent;

